/** How many of page one's rows Home's recent list shows before pointing at History. */
export const RECENT_SHOWN = 4

/**
 * The truncation sentence, or `null`.
 *
 * Shown whenever the card is not the whole of the history — because the page
 * held more rows than the card lists, or because a cursor says there is another
 * page. A list silently cut reads as the whole of a short history (§4.5).
 *
 * It counts the rows the card SHOWS (UI-QA Q9). It said "the 4" whatever the
 * card held, so a two-row first page with a cursor read "Showing the 4 most
 * recently uploaded." over two rows. Nothing more is loaded to repair it.
 */
export function recentCaption(rowCount: number, nextCursor: string | null): string | null {
  const shown = Math.min(rowCount, RECENT_SHOWN)
  const more = rowCount > shown || nextCursor !== null
  if (!more || shown === 0) return null
  return shown === 1 ? 'Showing the most recently uploaded recording.' : `Showing the ${shown} most recently uploaded.`
}
